import colors from 'assets/theme/base/colors';
import pxToRem from 'assets/theme/function/px-to-rem';
import { breakpoints } from 'assets/theme/base/breakpoints';

const radio = {
    styleOverrides: {
        root: {
            color: colors.primary.main,
            padding: pxToRem(5),

            '&.Mui-checked': {
                color: colors.primary.main,
            },

            '& .MuiSvgIcon-root': {
                fontSize: pxToRem(25),

                [breakpoints.down('sm')]: {
                    fontSize: pxToRem(20),
                },
            },
        },
    },
};

export default radio;
